import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';
import { useContext, useMemo } from 'react';
import { ProviderSoldTicket } from '../../TicketSold/TicketSoldForm';
import _ from "lodash";
import { useLocation } from 'react-router';

const TableCompareTicket = () => {


    const {
        form,
        statusId,
        isreRender,
        lstTotalTicketSell
    } = useContext(ProviderSoldTicket);

    const { watch } = form;
    const location = useLocation();

    const lstCompareTicket = useMemo(() => {
        const lstSoldTicket = watch("lstSoldTicket");
        const lstReturnTicket = watch("lstReturnTicket");
        const lstCompareTicket = watch("lstCompareTicket");

        if ([1, 2, 5].includes(statusId) || location.pathname === "/CommitteeTicketForm") {
            return lstCompareTicket;
        }

        lstCompareTicket.forEach(element => {

            //total withdraw
            let IndexTypeInSold = lstSoldTicket.findIndex(f => f.nTicketTypeID === element.nTicketTypeID && f.isNew === false);
            if (IndexTypeInSold !== -1) {

                element.nBookWithdraw = lstSoldTicket[IndexTypeInSold].nBookWithdraw;
                element.nTicketWithdraw = lstSoldTicket[IndexTypeInSold].nTicketWithdraw;
            }


            //Total input ticket from sold and not sum ticket lose in remark
            const sumTotalTickets = _.chain(lstSoldTicket)
                .filter(obj => obj.nTicketTypeID === element.nTicketTypeID)
                .sumBy('nTotalTicket')
                .value();

            element.nBookSold = element.nBookSold ?? 0;
            element.nTicketSold = element.nTicketSold ?? 0;
            element.nBookReturn = element.nBookReturn ?? 0;
            element.nTicketReturn = element.nTicketReturn ?? 0;


            let IndexTypeInReturn = lstReturnTicket.findIndex(f => f.nTicketTypeID === element.nTicketTypeID && f.nTotalTicket != null);
            let indexTypeTicket = lstTotalTicketSell.findIndex(f => f.nTicketTypeID === element.nTicketTypeID);
            if (indexTypeTicket !== -1 && IndexTypeInReturn !== -1) {

                let deepClone = lstTotalTicketSell[indexTypeTicket].lstOptionTicketCheck;
                let nRemarkSoldTicket = (_.countBy(deepClone, obj => obj.nStatusTicketId === 3)).true ?? 0;
                element.nTicketSold = sumTotalTickets + nRemarkSoldTicket;

                const filteredData = _.filter(deepClone, (item) => item.nStatusBookId === 6 || item.nStatusBookId === 7 || item.nStatusBookId === 2);
                const groupedData = _.groupBy(filteredData, 'nBookId');
                const filteredGroupedData = _.pickBy(groupedData, (group) => {
                    const nTicketPerBook = _.get(group[0], 'nTicketPerBook', 0);
                    const filterGroup = _.filter(group, (f) => f.nStatusTicketId != null);
                    return filterGroup.length === nTicketPerBook;
                });
                const countByBookId = _.mapValues(filteredGroupedData, (group) => group.length);
                element.nBookSold = Object.keys(countByBookId).length;

                let nReturnTicket = _.countBy(deepClone, obj => (obj.nStatusTicketId === 5 || obj.nStatusTicketId === 1));

                let groupCountBookReturn = _.chain(deepClone)
                    .filter(obj => obj.nStatusTicketId !== null && (obj.nStatusBookId === 5 || obj.nStatusBookId === 1))
                    .groupBy('nBookId')
                    .mapValues(group => group.length)
                    .value();

                let isCalDisplay = lstReturnTicket[IndexTypeInReturn].nStartTicketID && lstReturnTicket[IndexTypeInReturn].nStartTicketID !== 0 && lstReturnTicket[IndexTypeInReturn].nEndTicketID && lstReturnTicket[IndexTypeInReturn].nEndTicketID !== 0


                element.nTicketReturn = isCalDisplay ? nReturnTicket.true ?? 0 : 0;
                element.nBookReturn = isCalDisplay ? Object.keys(groupCountBookReturn).length : 0;
            }
            if (IndexTypeInReturn === -1) {
                element.nBookReturn = 0;
                element.nTicketReturn = 0;
            }
            element.isPass = element.nTicketWithdraw === (element.nTicketSold + element.nTicketReturn);

        });

        return lstCompareTicket;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isreRender, watch("lstSoldTicket"), watch("lstReturnTicket"), watch("lstCompareTicket")])


    return (
        <TableContainer id='table-receive' component={Paper}>
            <Table sx={{ minWidth: 1200 }} >
                <TableHead>
                    <TableRow>
                        <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '40px', width: '40px' }}>ที่</TableCell>
                        <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '250px', width: '250px' }}>ประเภทบัตร</TableCell>
                        <TableCell component="th" padding='none' colSpan={3}>จำนวนเล่ม</TableCell>
                        <TableCell component="th" padding='none' colSpan={3}>จำนวนใบ</TableCell>
                        <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '120px', width: '120px' }}>สถานะ</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>เบิก</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>จำหน่าย</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>คืน</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>เบิก</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>จำหน่าย</TableCell>
                        <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>คืน</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>

                    {
                        lstCompareTicket.map((row, index) => {
                            return (
                                <TableRow key={"tbcompare" + row.nTicketTypeID}>
                                    <TableCell align="center" >{index + 1}</TableCell>
                                    <TableCell align="left">
                                        {row.sTypeTicket}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.nBookWithdraw}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.nBookSold}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.nBookReturn}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.nTicketWithdraw}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.nTicketSold}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.nTicketReturn}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.isPass === true ? <Typography className='text-green'>ปกติ</Typography> : <Typography className='text-red'>ผิดปกติ</Typography>}
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }
                    {
                        lstCompareTicket.length === 0 ?
                            <TableRow >
                                <TableCell align="center" colSpan={9}>ไม่พบข้อมูล</TableCell>
                            </TableRow>
                            :
                            null
                    }
                </TableBody>
            </Table>
        </TableContainer>

    )
}

export default TableCompareTicket
